import React from 'react';
import './styles.scss';

import useReactRouter from 'use-react-router';

const Menu: React.FC = () => {
  const { history, location } = useReactRouter();

  return (
    <nav>
      <div
        className={location.pathname === '/' ? `item active` : 'item'}
        onClick={() => history.push('/')}
      >
        Calcule o seu <br /> risco venoso
      </div>
      {/* <div
        className={location.pathname === '/riscos' ? `item active` : 'item'}
        onClick={() => history.push('/riscos')}
      >
        Compreenda os riscos <br /> da Doença Venosa Crônica
      </div> */}
      <div
        className={location.pathname === '/sobre' ? `item active` : 'item'}
        onClick={() => history.push('/sobre')}
      >
        Sobre o Vein Risk
      </div>
      <div
        className={location.pathname === '/termos' ? `item active` : 'item'}
        onClick={() => history.push('/termos')}
      >
        Termos e condições <br /> de utilização
      </div>
    </nav>
  );
};

export default Menu;
